// 需要 jquery   slick

if (!customElements.get("scroll-store-message")) {
    customElements.define(
      "scroll-store-message",
      class ScrollStoreMessage extends HTMLElement {
        constructor(){
          super();
          this.marqueeDom = $(this).find('.marquee');
          this.initMarquee();
        }

        initMarquee(){
          const that = this;
          setTimeout(function(){
            $(that).find('.marquee').marquee({
              direction: 'right',   // 👈 新增这一行：设置滚动方向为向左（即从右到左）
              startVisible : true,
              duplicated : true,
              speed: 40,
              pauseOnHover: true,
              loop: -1,
              pauseSpeed: 0
            });
          },0)
        }
      }
    )
}